import { render, staticRenderFns } from "./FileImageView.vue?vue&type=template&id=c84f6194&scoped=true&"
import script from "./FileImageView.vue?vue&type=script&lang=ts&"
export * from "./FileImageView.vue?vue&type=script&lang=ts&"
import style0 from "./FileImageView.vue?vue&type=style&index=0&id=c84f6194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84f6194",
  null
  
)

export default component.exports